import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { number, string } from 'prop-types';
import { defaultTo } from 'ramda';
// import { formatLastUsed } from 'feature/loading-management/utils/timeHelpers';

// styles
import { labelsStyles, numbersStyles } from '../Card.styles';

const CardBody = ({ authorizationCount, /* lastUsed, */ listType }) => {
  const theme = useTheme();

  const countCopy = listType === 'supplierDirectedBlends' ? 'Customers' : 'Suppliers';

  return (
    <>
      <Typography gridColumn="span 3" sx={{ ...labelsStyles(theme) }}>
        {countCopy}
      </Typography>
      {/* TODO: temporarily commenting out the last used Date(CTDP-125)
      {/* <Typography classes={{ root: labels }}>Last Used</Typography> */}
      <Typography data-testid="authorization-count" gridColumn="span 3" sx={numbersStyles(theme)}>
        {defaultTo('--', authorizationCount)}
      </Typography>
      {/* <Typography classes={{ root: numbers }} data-testid="last-used">
        {formatLastUsed(lastUsed)}
      </Typography> */}
    </>
  );
};

CardBody.propTypes = {
  authorizationCount: number,
  // lastUsed: string,
  listType: string.isRequired,
};

CardBody.defaultProps = {
  authorizationCount: null,
  // lastUsed: null,
};

export default CardBody;
